import { TbBrandReact } from "react-icons/tb";
import { TbBrandWordpress } from "react-icons/tb";
import { TbBrandFramer } from "react-icons/tb";
import { TbBrandFigma } from "react-icons/tb";
import { TbDeviceDesktopCode } from "react-icons/tb";
import { TbDeviceMobileDollar } from "react-icons/tb";
import { TbBrandReactNative } from "react-icons/tb";
import { TbBrandFirebase } from "react-icons/tb";

export const cardsData =
[
    {
        title: 'WEB DEVELOPMENT',
        icons: [TbBrandReact, TbBrandFramer, TbBrandWordpress],
        desc: `Develop high-performance websites using advanced technologies like React,
        Framer, and WordPress. My expertise ensures robust CMS integration, seamless user experiences,
        and optimized performance, empowering your digital presence to achieve measurable success.`
    },{
        title: 'APP DEVELOPMENT',
        icons: [TbBrandReactNative, TbBrandFirebase],
        desc: `Engineer versatile mobile applications with React Native, delivering exceptional
        performance across iOS and Android platforms. I specialize in creating apps that are visually compelling,
        user-friendly, and secure, providing a flawless experience on any device.`
    },{
        title: 'WEB DESIGN',
        icons: [TbBrandFigma],
        desc: `Craft bespoke web designs that resonate with your brand’s identity. My designs are meticulously
        engineered to be visually striking and intuitive, enhancing user engagement and driving meaningful conversions.`
    },{
        title: 'CONTENT & SEO',
        icons: [TbDeviceDesktopCode, TbDeviceMobileDollar],
        desc: `Elevate your online authority with strategic content creation and SEO. I produce high-quality,
        optimized content that connects with your target audience, driving sustainable growth and enhancing your brand’s visibility.`}
]